import Icon from "@/components/Icon/Icon";
import { HStack, VStack } from "@/components/Layout";
import { Text } from "@/components/Typography/Text";
import { defaultNS, useTranslation } from "@/lib/i18n";

export type PersonPreviewData = {
  /**
   * 従業員番号
   */
  workerNumber?: string;
  /**
   * メールアドレス
   */
  email?: string;
};

type Props = {
  /**
   * 人物情報
   */
  person: PersonPreviewData;
  /**
   * クラス名
   */
  className?: string;
};

/**
 * 人物プレビューカードのコンテンツコンポーネント
 */
export function UnknownPreviewContent({ person, className }: Props) {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "component.dataTable.cells.PersonCell",
  });

  return (
    <VStack className={className}>
      <VStack className="gap-2 max-w-2xl">
        <HStack className="items-center gap-2">
          <Text variant="label" className="text-error-on-neutral-fill">
            {t("unknownPerson")}
          </Text>
          {person.workerNumber && (
            <Text variant="label">{person.workerNumber}</Text>
          )}
        </HStack>
        {person.email && (
          <HStack className="items-center gap-2">
            <Icon iconName="Mail" />
            <Text variant="label" className="truncate">
              {person.email ?? "-"}
            </Text>
          </HStack>
        )}
      </VStack>
    </VStack>
  );
}
